import gql from 'graphql-tag'

export default gql`
  mutation ChangePassword(
    $email: String!,
    $code: String!,
    $password: String!
  ) {
    changePassword(
      email: $email,
      code: $code,
      password: $password
    ) {
      id
    }
  }
`
